import * as Vue from 'vue';
import * as VueRouter from 'vue-router';
import i18next from 'i18next';
import FestCardPackage from './components/FestCardPackage.vue';

const All = () => import("./components/HelloWorld.vue");
const PrivateParking = () => import("./components/PrivateParking.vue");
const PublicParking = () => import("./components/PublicParking.vue");
const FestCard = () => import("./components/FestCard.vue");
const Clamps = () => import("./components/Clamps.vue");
const Events = () => import("./components/Events.vue");
const EventsListing = () => import("./components/EventsListing.vue");
const CheckPayment = () => import("./components/CheckPayment.vue");
const DEFAULT_TITLE = 'QR Payment software';

const router = VueRouter.createRouter({
    history: VueRouter.createWebHashHistory(),
    // history: VueRouter.createWebHistory(),
    // mode: 'history',
    routes: [
        {
            path: '/pp/:hash/:number?',
            component: PrivateParking
        },
        {
            path: '/zp/:hash',
            component: PublicParking
        },
        {
            path: '/cl/:hash',
            component: Clamps
        },
        {
            path: '/ev/:hash',
            component: Events
        },
        {
            path: '/evs/:eventId',
            component: Events
        },
        {
            path: '/evl/:hash',
            component: EventsListing
        },
        {
            path: '/fc/:hash/:response?',
            component: FestCard
        },
        {
            path: '/fcp/:hash/:response?',
            component: FestCardPackage
        },
        {
            path: '/payment/:type/:orderId/:response?/:card?',
            component: CheckPayment
        },
        {
            path: '/',
            component: All
        },
    ]
});

// router.beforeEach((to,from,next) => {
//     if (to.fullPath == '/' || to.fullPath == '/pp' || to.fullPath == '/pp/') {
//         next('pp/34286c0fe2fe5c76e24d9cfa7d6990ac')
//     }else{
//         next()
//     }
// });
let changingFromUrl = false;

// Allow switching language via ?lng=en inside the hash url (e.g. #/pp/abc?lng=en)
router.beforeEach((to) => {
    const lng = String(to.query.lng || to.query.lang || '').toLowerCase().slice(0, 2);
    if (['bg', 'en'].includes(lng) && i18next.language !== lng) {
        changingFromUrl = true;
        return i18next.changeLanguage(lng).then(() => true).finally(() => { changingFromUrl = false; });
    }
});

// Keep an existing lng/lang url parameter in sync when the language is switched,
// so a reload or a shared link opens in the same language
i18next.on('languageChanged', (lng) => {
    if (changingFromUrl) {
        return;
    }

    const search = new URLSearchParams(window.location.search);
    const searchKey = ['lng', 'lang'].find((key) => search.has(key));
    if (searchKey && search.get(searchKey) !== lng) {
        search.set(searchKey, lng);
        const url = window.location.pathname + '?' + search.toString() + window.location.hash;
        window.history.replaceState(window.history.state, '', url);
    }

    const route = router.currentRoute.value;
    const hashKey = ['lng', 'lang'].find((key) => key in route.query);
    if (hashKey && route.query[hashKey] !== lng) {
        router.replace({ query: { ...route.query, [hashKey]: lng } });
    }
});

router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router;